import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "InvoiceNotificationListPage" */
	'pages/invoice/InvoiceNotification/InvoiceNotificationListPage'));

export default [{ component, exact: true, path: '/invoice_notifications' }];